import { render, staticRenderFns } from "./NewSimulationCompete.vue?vue&type=template&id=1c856606&scoped=true&"
import script from "./NewSimulationCompete.vue?vue&type=script&lang=js&"
export * from "./NewSimulationCompete.vue?vue&type=script&lang=js&"
import style0 from "./NewSimulationCompete.vue?vue&type=style&index=0&id=1c856606&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c856606",
  null
  
)

export default component.exports